import { TableCell } from "@mui/material";
import { styled } from "@mui/system";
import { memo } from "react";

const style = {
    width: "98vw",
    height: "80vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden", // Prevents parent overflow
};

const CustomTableCell = memo(styled(TableCell)({
    padding: "4px",
    backgroundColor: "transparent !important",
}))
const linkStyle = {
    color: "blue", // Link color
    textDecoration: "none", // No underline by default
    cursor: "pointer", // Show pointer cursor
    "&:hover": {
        textDecoration: "underline", // Underline on hover
    },
    "&:active": {
        color: "darkblue", // Darker color when clicked
    },
    "&:visited": {
        color: "purple", // Change color if the link was visited
    },
};

const cellStyle = {
    textAlign: "right",
    fontWeight: "bold",
    fontSize: "17px",
    color: "#000",
}

export { CustomTableCell, linkStyle, style, cellStyle }
